import { Injectable } from '@angular/core';

import { EntregaPreCargaModel } from '../models/entregas-pre-carga.model';

@Injectable({
  providedIn: "root",
})
export class EntregaPreCargaService {
  constructor() {}

  calcularValores(entregaPreCarga: EntregaPreCargaModel) {
    return entregaPreCarga.pedidos.reduce(
      ({ peso, volume, valor }, { pesoTotal, volumeTotal, valorTotal }) => ({
        peso: pesoTotal + peso,
        volume: volumeTotal + volume,
        valor: valorTotal + valor,
      }),
      { peso: 0, volume: 0, valor: 0 }
    );
  }

  public obterEntregaPorIdClienteEIdEnderecoEntrega(
    entregasPreCarga: EntregaPreCargaModel[],
    idCliente: string,
    idEnderecoEntrega: string
  ) {
    const idEndEnt = idEnderecoEntrega === "0" ? null : idEnderecoEntrega;

    return entregasPreCarga.find(
      (entrega) =>
        entrega.idCliente === idCliente &&
        (entrega.idEnderecoEntrega === idEndEnt ||
          entrega.idEnderecoEntrega === '0' || entrega.idEnderecoEntrega === '')
    );
  }
}
